import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { combineLatest, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { DocumentPaService } from "../../services/document-pa-service";
import { applicationConstants } from '../../../../app.constants';

import { DocumentEchange } from '../../entities/document-pa-echange';

@Component({
	selector: 'pa-generation',
	templateUrl: 'pa-generation.html',
	styleUrls: ['pa-generation.css'],
})
export class PaGenerationComponent {
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	paId: number = -1;
	documentsCoches: string[] = [];
	annexes: NgxFileDropEntry[] = [];
	formData: FormData = new FormData();
	
	constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService) {
	}

	@Input() id = 'paGenerationDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	@Input() set generationCommands(obs: Observable<number>) {
		obs.subscribe(
			// lors de la reception d'une demande d'affichage du popup d egeneration
			(pa: number) => {
				console.log('demande affichage popup generation pour le PA: ');
		     	this.paId = pa;
				this.loadDocumentsCoches(pa); 
		     	this.displaySubject.next(true);
			}
	 	);
	}

	// Evenements de validation de l'operation en cours (s'il y en a)
	@Output() decisionIssued = new EventEmitter<boolean>();
	
	reinitForm() {
		this.paId = -1;
		this.documentsCoches = [];
		this.annexes = [];
		this.formData = new FormData();
		this.displaySubject.next(false);
	}

	onCloseRequested() {
		this.reinitForm();
		this.decisionIssued.emit(false);
	}
	
	generatePdf() {
		console.log('appel au serveur pour générer le pdf du Pa id: ',this.paId);
		const fileName: string = 'document-personne-avertie-' + this.paId.toString() + '.pdf';
		this.formData.append('idPa', this.paId.toString());
		
		this.documentPaService.generatePdf(this.formData).subscribe(
			(blob: Blob) => {
				const objectUrl: string = URL.createObjectURL(blob);
				const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
				a.href = objectUrl;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();        
				
				document.body.removeChild(a);
				URL.revokeObjectURL(objectUrl);
  			},
			(err: any) => {
    			console.log('Could not upload the file, error: ', err);
			}
		);
		this.reinitForm();
		this.decisionIssued.emit(true);
	}
	
	dropped(files: NgxFileDropEntry[]) {
    	for (const droppedFile of files) {
      		// Is it a file?
 			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					console.log(droppedFile.relativePath, file);
					if (file.type === applicationConstants.pdpAutorizedAnnexeType && !this.alreadyAdded(droppedFile)) {
						this.annexes.push(droppedFile);
						const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
						let i: number = 1;
						fileEntry.file((file: File) => {
							const fileName = 'annexe-' + i++ + '.pdf';
							this.formData.append('annexes', file, fileName);
						});
					} else {
						console.log('ignoré par l\'import: ', file);
					}
        		});
			} else {
				// les dossiers sont ignorés par l'import
				console.log('dossier ignoré par l\'import: ', droppedFile);
      		}
		}
	}
	
	private loadDocumentsCoches(paId: number): void {
	    this.documentsCoches = [];
	    if (paId == null || paId < 0) return;

	    combineLatest([
	        this.documentPaService.getDocumentsEchange(),
	        this.documentPaService.getDocumentEchangeData(paId)
	    ]).pipe(
			map(([docs, stepData]: [DocumentEchange[], any]) => {
			    const saved: { id: number, checked: boolean }[] = stepData?.documentEchanges ?? [];
			    return docs
			        .filter((doc: DocumentEchange) => saved.length
			            ? (saved.find(s => s.id === doc.id)?.checked ?? false)
			            : doc.customFields === 'preSelected')
			        .map((doc: DocumentEchange) => doc.libelle ?? '')
			        .filter((libelle: string) => libelle.length > 0);
			})
	    ).subscribe((libelles: string[]) => this.documentsCoches = libelles);
	}
	
	private alreadyAdded(fileEntry: NgxFileDropEntry) {
		return this.annexes.some( e => e.relativePath === fileEntry.relativePath );
	}
	
	public removeFile(item: NgxFileDropEntry) {
		console.log('demande suppression fichier: ', item);
		this.annexes = this.annexes.filter( file => file.relativePath !== item.relativePath );
	}

	public fileOver(event: Event){
    	console.log(event);
	}

	public fileLeave(event: Event){
		console.log(event);
	}
}